var map = {
	"./telaCinza (1).jpg": 4332,
	"./telaCinza (1).png": 2392,
	"./telaCinza (10).png": 7636,
	"./telaCinza (11).png": 1793,
	"./telaCinza (2).png": 7837,
	"./telaCinza (3).png": 4367,
	"./telaCinza (4).png": 8917,
	"./telaCinza (5).png": 2499,
	"./telaCinza (6).png": 9718,
	"./telaCinza (7).png": 9933,
	"./telaCinza (8).png": 9161,
	"./telaCinza (9).png": 1786
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6513;